import {Col} from 'react-bootstrap';
import logoImg from "../assets/netcomet.png";


export function NotFound() {

	return(
		<div className="vh-100 justify-content-center align-items-center d-grid ms-3 me-3">
			<Col md={12} sm={12} className="text-center">
				<img src={logoImg} className="mb-5" alt="Logo Netcomet"/>
				<h5 className="justify-content-center align-items-center d-flex w-100">
					Página não encontrada
				</h5>
			</Col>
		</div>
	);
}
